/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Profile({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout/Appointments/Content/Appointment/Profile",
  presignedUrl
  
}) {
let appointmentBookingPatientPersonValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_booking',
path: 'patient_person',
format: fromFormat.initials,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  presignedUrl
  
})
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 onClick={onClick}
 profile_url={presignedUrl}
 data="appointment_booking.patient_person"
 format="/Data/format.js initials"
 initials={appointmentBookingPatientPersonValueData}
 size="medium"
 marginRight={dtSpaceXs}
/>
{children}
</React.Fragment>)
}